<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import useVuelidate from "@vuelidate/core";
import {helpers, required} from "@vuelidate/validators";
import Swal from "sweetalert2";
import Loader from "../components/loader";
import api from "@/axios";
import {getBaseUrl} from "@/helpers/baseUrl";


export default {
  page: {
    title: "Editar Tipo de Operação",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, Loader },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      errosValid: null,
      contClickAvanc: 0,
      pedTipoData: {
        id: 0,
        status: 'A'
      },

      idData: 0,
      updating: true,
      activeTab: 0,
      submitted: false,

      title: "Editar Tipo de Operação",
      items: [
        {
          text: "Tipo de Operação",
          href: "/tiposopera/list",
        },
        {
          text: "Editar Tipo de Operação",
          active: true,
        },
      ],
    };
  },
  validations: {
    pedTipoData: {
      descricao: {
        required: helpers.withMessage("Campo descricao obrigatório, favor preencher.", required),
      },

      cnpj: {
        required: helpers.withMessage("Campo CNPJ obrigatório, favor preencher.", required),
      },
      tipo: {
        required: helpers.withMessage("Campo Tipo obrigatório, favor preencher.", required),
      },
      codigo: {
        required: helpers.withMessage("Campo código obrigatório, favor preencher.", required),
      },
      cep: {
        required: helpers.withMessage("Campo CEP obrigatório, favor preencher.", required),
      },
      rua: {
        required: helpers.withMessage("Campo logradouro obrigatório, favor preencher.", required),
      },
      bairro: {
        required: helpers.withMessage("Campo bairro obrigatório, favor preencher.", required),
      },
      numero: {
        required: helpers.withMessage("Campo número obrigatório, favor preencher.", required),
      },
      cidade: {
        required: helpers.withMessage("Campo cidade obrigatório, favor preencher.", required),
      },
      estado: {
        required: helpers.withMessage("Campo estado obrigatório, favor preencher.", required),
      },
    }
  },
  methods: {

    avancarSeg(){
      console.log('avancarSeg')
      this.submitted = true
      this.v$.$touch()
      console.log(this.v$.$invalid)
      if (!this.v$.$invalid){
        console.log('avancarSeg_ok')
        this.activeTab = 1
      }
      if(this.contClickAvanc > 0){
        this.activeTab = 1
      }
      this.contClickAvanc += 1

    },

    formSubmit(){
      console.log('formSubmit')
      this.submitted = true;
      this.v$.$touch()
      console.log(this.pedTipoData)


      this.updating = true
      this.errosValid = []
      api.post(`${getBaseUrl()}api/tipoopera`, {
        pedTipoData: this.pedTipoData
      }).then((res) => {
        console.log('then axios')
        console.log(res)
        this.pedTipoData = res.data[0]
        this.updating = false

        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Informações salvas com sucesso!",
          showConfirmButton: false,
          timer: 1500
        })
        this.$router.push('/tiposopera/list')
      }).catch((err) => {
        console.log('erro axios')
        // console.log(err)
        // console.log(err.response)
        // console.log(err.response.data.errors)
        let erros = err.response.data.errors
        console.log(erros)
        console.log(typeof  erros)
        let listaErros = []
        Object.keys(erros).forEach(key => {
          console.log(key, erros[key]);
          listaErros.push({
            'titulo': key,
            'mensagem': erros[key]
          })
        });
        this.errosValid = listaErros
        this.updating = false
        this.activeTab = 0
      })


    },

  },
  mounted() {
    console.log('mounted_tipoopera_editar_0')
    let rota = this.$route.path
    // console.log(rota)
    let ultimaBarra = rota.lastIndexOf('/')
    if (ultimaBarra){
      this.idData = parseInt(rota.substring(ultimaBarra + 1))
    }
    console.log(`idData: ${this.idData}`)
    if (this.idData > 0){
      api.get(`${getBaseUrl()}api/tipoopera`, {
        params: { iddata: this.idData }
      }).then((res) => {
        console.log('then axios')
        // console.log(res.data)
        if (res.data.error){
          console.log(res.data.error)
          this.$router.push(`/faltapermissao`);
        }else{
          this.pedTipoData = res.data[0]
          if (res.data[1]){
            // this.enderecosData = res.data[1]
          }
          this.idData = this.pedTipoData.id
          this.title = `Editar Tipo de Operação (${this.pedTipoData.id}) ${this.pedTipoData.descricao}`
          this.updating = false
        }
      });
    }else{

      this.title = `Criando Novo Tipo de Operação`
      this.updating = false
    }


  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <Loader v-if="updating" style="min-height: 400px;">
    </Loader>

    <div class="checkout-tabs" v-if="!updating">

      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-start">

              <b-button variant="outline-primary" class="mx-2" @click="formSubmit"  >
                <i class="bx bx-save font-size-16 align-middle me-2"></i>
                Salvar Alterações
              </b-button>

              <!--              <b-button variant="outline-info" class="mx-2" v-if="idData > 0" @click="imprimirOrcamento">-->
              <!--                <i class="bx bx-printer font-size-16 align-middle me-2"></i>-->
              <!--                Imprimir-->
              <!--              </b-button>-->

              <!--              <b-button variant="outline-info" class="mx-2" v-if="idData > 0" @click="copiarOrcamento">-->
              <!--                <i class="bx bx-copy font-size-16 align-middle me-2" ></i>-->
              <!--                Copiar-->
              <!--              </b-button>-->

              <!--              <b-button variant="outline-danger" class="mx-2" @click="cancelarOrcamento"  >-->
              <!--                <i class="bx bxs-trash font-size-16 align-middle me-2"></i>-->
              <!--                Cancelar Orçamento-->
              <!--              </b-button>-->

              <!--              <b-button variant="outline-warning" class="mx-2" @click="novoAnexo" :disabled="clienteData.id === 0">-->
              <!--                <i class="bx bx-plus-circle font-size-16 align-middle me-2"></i>-->
              <!--                Novo Anexo-->
              <!--              </b-button>-->

            </div>
          </div>
        </div>
      </div>

      <b-tabs
          v-model="activeTab"
          pills
          vertical
          nav-class="p-0"
          nav-wrapper-class="col-xl-2 col-sm-3"
          content-class="w-100">
        <b-tab>
          <template v-slot:title>
            <i class="bx bxs-briefcase d-block check-nav-icon mt-4 mb-2"></i>
            <p class="fw-bold mb-4">Principal</p>
          </template>
          <b-card-text>
            <div class="card">
              <div class="card-body">
                <h4 class="card-title">Informações Principais</h4>
<!--                <p class="card-title-desc">Favor preencher corretamente os campos abaixo</p>-->

                <form class="needs-validation">
                  <div class="row">

                    <div class="col-md-4">
                      <div class="mb-3">
                        <label for="descricao">Descrição</label>
                        <input
                            id="descricao"
                            v-model="pedTipoData.descricao"
                            type="text"
                            class="form-control"
                            placeholder="Descrição"
                            :class="{'is-invalid': submitted && v$.pedTipoData.descricao.$error,}"/>
                        <div v-if="submitted && v$.pedTipoData.descricao.$error"
                             class="invalid-feedback">
                          <span v-if="v$.pedTipoData.descricao.required.$message">{{ v$.pedTipoData.descricao.required.$message }}</span>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-4">
                      <label for="codigo">Código</label>
                      <div class="position-relative">
                        <input
                            id="codigo"
                            type="text"
                            v-model="pedTipoData.codigo"
                            class="form-control"
                            placeholder="Código"
                            :class="{'is-invalid': submitted && v$.pedTipoData.codigo.$error,}"/>
                        <div v-if="submitted && v$.pedTipoData.codigo.$error" class="invalid-feedback">
                          <span v-if="v$.pedTipoData.codigo.required.$message">{{ v$.pedTipoData.codigo.required.$message }}</span>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-4">
                      <div class="mb-3">
                        <label for="tipo">Tipo</label>
                        <select
                            id="tipo"
                            v-model="pedTipoData.tipo"
                            class="form-control"
                            :class="{'is-invalid': submitted && v$.pedTipoData.tipo.$error,}">
                          <option value="ENT">Entrada</option>
                          <option value="SAI">Saída</option>
                          <option value="TRF">Transferência</option>
                        </select>
                        <div v-if="submitted && v$.pedTipoData.tipo.$error" class="invalid-feedback">
                          <span v-if="v$.pedTipoData.tipo.required.$message">{{ v$.pedTipoData.tipo.required.$message }}</span>
                        </div>
                      </div>
                    </div>


                  </div>


                  <div class="row">

                    <div class="col-md-4">
                      <div class="mb-3">
                        <label for="vlrmin">Valor Mínimo</label>
                        <input
                            id="vlrmin"
                            v-model="pedTipoData.vlrmin"
                            type="number"
                            class="form-control"
                            placeholder="Valor Mínimo"/>
                      </div>
                    </div>


                    <div class="col-md-4">
                      <div class="mb-3">
                        <label for="pagrec">Tipo</label>
                        <select
                            id="pagrec"
                            v-model="pedTipoData.pagrec"
                            class="form-control">
                          <option value="PG">Pagar</option>
                          <option value="RC">Receber</option>
                        </select>

                      </div>
                    </div>


                  </div>



                  <div class="row">

                    <div class="col-sm-3">
                      <div class="mb-3">
                        <h5 class="font-size-14">Status</h5>
                        <b-form-checkbox
                            switch size="lg"
                            value="A"
                            unchecked-value="I"
                            v-model="pedTipoData.status">
                          {{ pedTipoData.status === 'A' ? 'Ativo' : 'Inativo' }}
                        </b-form-checkbox>
                      </div>
                    </div>

                    <div class="col-sm-3">
                      <div class="mb-3">
                        <h5 class="font-size-14">Emissor NFe</h5>
                        <b-form-checkbox
                            switch size="lg"
                            value="A"
                            unchecked-value="I"
                            v-model="pedTipoData.stsnfe">
                          {{ pedTipoData.stsnfe === 'A' ? 'Ativo' : 'Inativo' }}
                        </b-form-checkbox>
                      </div>
                    </div>


                  </div>


<!--                  <div class="row">-->

<!--                    <div class="col-md-12">-->
<!--                      <div class="mb-3">-->
<!--                        <label for="obs">Observações</label>-->
<!--                        <textarea-->
<!--                            id="obs"-->
<!--                            v-model="pedTipoData.obs"-->
<!--                            type="text"-->
<!--                            rows="3"-->
<!--                            class="form-control"-->
<!--                            placeholder="Observações"/>-->
<!--                      </div>-->
<!--                    </div>-->

<!--                  </div>-->
                </form>

              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-6">
                <router-link
                    to="/tiposopera/list"
                    class="btn text-muted d-none d-sm-inline-block btn-link"
                >
                  <i class="mdi mdi-arrow-left me-1"></i> Voltar para Tipos de Operações
                </router-link>
              </div>
              <!-- end col -->
              <div class="col-sm-6">
                <div class="text-end">
                  <button class="btn btn-success" @click="avancarSeg">
                    Avançar para Parâmetros
                    <i class="mdi mdi-arrow-right me-1"></i>
                  </button>
                </div>
              </div>
              <!-- end col -->
            </div>
          </b-card-text>
        </b-tab>
        <b-tab>
          <template v-slot:title>
            <i class="bx bx-cog d-block check-nav-icon mt-4 mb-2"></i>
            <p class="fw-bold mb-4">Parâmetros</p>
          </template>
          <b-card-text>
            <div class="card">
              <div class="card-body">
                <div>
                  <h4 class="card-title">Parâmetros</h4>
<!--                  <p class="card-title-desc">Favor preencher corretamente os campos abaixo</p>-->

                  <h5 class="font-size-15 text-end">Integração Nota Fiscal Eletrônica</h5>
                  <div class="p-4 border">
                    <form>
                      <div class="row">
                        <div class="col-md-2">
                          <label for="proxnumero">Próximo Número</label>
                          <div class="position-relative">
                            <input
                                id="proxnumero"
                                type="text"
                                v-model="pedTipoData.proxnumero"
                                class="form-control"
                                placeholder="Próximo número de documento"/>

                          </div>
                        </div>


                        <div class="col-md-2">
                          <div class="mb-2">
                            <label for="serie">Série</label>
                            <select
                                id="serie"
                                v-model="pedTipoData.serie"
                                class="form-control">
                              <option>1</option>
                              <option>2</option>
                              <option>3</option>
                            </select>
                          </div>
                        </div>



                        <div class="col-md-3">
                          <div class="mb-3">
                            <label for="especie">Espécia</label>
                            <input
                                id="especie"
                                v-model="pedTipoData.especie"
                                type="text"
                                class="form-control"
                                placeholder="Espécia de documento"/>

                          </div>
                        </div>


                        <div class="col-md-2">
                          <div class="mb-2">
                            <label for="cfop">CFOP</label>
                            <input
                                id="cfop"
                                v-model="pedTipoData.cfop"
                                list="datalistCFOPS"
                                class="form-control"
                                placeholder="pesquisar CFOP..."/>
                            <datalist id="datalistCFOPS">
                              <option value="5.102"></option>
                              <option value="5.103"></option>
                              <option value="5.104"></option>
                              <option value="5.105"></option>
                              <option value="5.106"></option>
                            </datalist>
                          </div>
                        </div>



                      </div>
                    </form>
                  </div>


                  <h5 class="mt-3 font-size-15 text-end">Integração Financeira</h5>
                  <div class="p-4 border">

                  </div>


                </div>
              </div>
            </div>


            <div class="row mt-4">
              <div class="col-sm-6">
                <button
                    @click="activeTab = 0"
                    class="btn text-muted d-none d-sm-inline-block btn-link"
                >
                  <i class="mdi mdi-arrow-left me-1"></i> Voltar para Principal
                </button>
              </div>
              <!-- end col -->
              <div class="col-sm-6">
                <div class="text-end">
                  <button
                      @click="activeTab = 2"
                      class="btn btn-success">
                    Avançar para Restrições
                    <i class="mdi mdi-arrow-right me-1"></i>
                  </button>
                </div>
              </div>
              <!-- end col -->
            </div>
          </b-card-text>

        </b-tab>
        <b-tab>
          <template v-slot:title>
            <i class="bx bx-user-check d-block check-nav-icon mt-4 mb-2"></i>
            <p class="fw-bold mb-4">Restrições</p>
          </template>
          <b-card-text>
            <div class="card">
              <div class="card-body">
                <div class="card shadow-none border mb-0">
                  <div class="card-body">
                    <h4 class="card-title mb-4">Restrições</h4>
                    <p class="card-title-desc">Veja abaixo as Restrições deste tipo de operação</p>

                    <div class="table-responsive">
                      <table class="table align-middle mb-0 table-nowrap">
                        <thead class="table-light">
                        <tr>
                          <th scope="col">Data Início</th>
                          <th scope="col">Data Fim</th>
                          <th scope="col">Usuário</th>
                          <th scope="col">Tipo</th>
                        </tr>
                        </thead>
                        <tbody>

                        <tr>

                          <td>
                            <h5 class="font-size-14 text-truncate">
                              <span class="text-dark">
                                01/05/2023
                              </span>
                            </h5>
                          </td>


                          <td>
                            <h5 class="font-size-14 text-truncate">
                              <span class="text-dark">

                              </span>
                            </h5>
                          </td>

                          <td>José da Silva</td>

                          <td>
                            <h5 class="font-size-14 text-truncate">
                              <span class="text-dark">
                                Bloqueio de Acesso
                              </span>
                            </h5>
                          </td>


                        </tr>

                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row mt-4">
              <div class="col-sm-6">
                <button
                    @click="activeTab = 1"
                    class="btn text-muted d-none d-sm-inline-block btn-link"
                >
                  <i class="mdi mdi-arrow-left me-1"></i> Voltar para Parâmetros
                </button>
              </div>


            </div>
          </b-card-text>
        </b-tab>
      </b-tabs>
    </div>

    <b-alert v-for="(erro, i) in errosValid" :key="`alerta-${i}`"   show dismissible variant="danger" >
      <i class="mdi mdi-alert me-2"></i>Pendente validação de campo: {{ erro.titulo }} -- {{ erro.mensagem[0] }} --
      favor ajustar e tentar novamente.
    </b-alert>

  </Layout>
</template>
